import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectIsNotSummaryPage } from 'src/app/store/router/router.selectors';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

@Injectable()
export class IsNotSummaryResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsNotSummary;

  public constructor(private readonly store: Store) {}

  public resolve$(): Observable<boolean> {
    return this.store.select(selectIsNotSummaryPage);
  }
}
